import _objectSpread from "/var/lib/jenkins/workspace/CB-Culturebie-Frontend-Prod/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import productConstants from './productConstants';
import bannerConstants from './bannerConstants';
import contactPageConstants from './contactPageConstants';
import servicesConstants from './servicesConstants';
import teamsConstants from './teamConstants';
import resourcesConstants from './resourcesConstants';
import footerConstants from './footerConstants';
export default _objectSpread({}, footerConstants, productConstants, bannerConstants, contactPageConstants, servicesConstants, teamsConstants, resourcesConstants);